import type { PaginationParams, PaginationType } from '../types/Pagination.types';
import type { CategoryDto, CategoryListItemDto, CategoryListParams } from './categories.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationParamsSchema, PaginationSchema } from '../types/Pagination.types';
import { CategoryDtoSchema, CategoryListItemDtoSchema, CategoryParamsSchema } from './categories.schema';

export const categoriesApi = {
  /**
   * @deprecated This method is deprecated. Use the new categories query method instead.
   */
  async getAll(params: PaginationParams<any>) {
    const validatedParams = validateWithZod(PaginationParamsSchema(), params);

    const response = await httpClient.get<PaginationType<CategoryListItemDto>>(
      ENDPOINTS.categories.all,
      { params: validatedParams },
    );

    return validateWithZod(PaginationSchema(CategoryListItemDtoSchema), response);
  },

  async fetchAll(params?: CategoryListParams) {
    const validatedParams = params ? validateWithZod(CategoryParamsSchema, params) : undefined;

    const response = await httpClient.get<PaginationType<CategoryListItemDto>>(
      ENDPOINTS.categories.all,
      { params: validatedParams },
    );

    return validateWithZod(PaginationSchema(CategoryListItemDtoSchema), response);
  },

  /**
   * @deprecated This method is deprecated. Use the new categories query method instead.
   */
  async getById(id: string) {
    const response = await httpClient.get<CategoryDto>(ENDPOINTS.categories.byId(id));

    return validateWithZod(CategoryDtoSchema, response);
  },

  async fetchById(id: string) {
    const response = await httpClient.get<CategoryDto>(ENDPOINTS.categories.byId(id));

    return validateWithZod(CategoryDtoSchema, response);
  },

  async getByName(name: string) {
    const response = await httpClient.get<CategoryDto>(ENDPOINTS.categories.byName(name));

    return validateWithZod(CategoryDtoSchema, response);
  },
};
